import { ClientsRoutes } from '@/features/clients/routes/routes';
import { ComplaintsRoutes } from '@/features/complaints/routes/routes';
import { ContactRoutes } from '@/features/contact/routes/routes';
import { PricingRoutes } from '@/features/pricing/routes/routes';
import { PrivacyPolicyRoutes } from '@/features/privacyPolicy/routes/routes';
import { ProductsRoutes } from '@/features/products/routes/routes';
import { ServicesRoutes } from '@/features/services/routes/routes';
import { SignUpRoutes } from '@/features/signUp/routes/routes';
import { TermsAndConditionsRoutes } from '@/features/termsAndConditions/routes/routes';
import { UsRoutes } from '@/features/us/routes/routes';
import LocaleLayout from '@/Layouts/LocaleLayout';
import LocaleRedirect from '@/Layouts/LocaleRedirect';
import { lazy } from 'react';

//-------------------------------------------------------------------

const Home = lazy(() => import('@/features/homePage/pages/Home.page'));
const SignUp = lazy(() => import('@/features/signUp/pages/SignUp.page'));
const LoginPage = lazy(() => import('@/features/signUp/pages/Login.page'));
const ClinicoSignUp = lazy(() => import('@/features/signUp/pages/ClinicoSignUp.page'));
const CheckoutPage = lazy(() => import('@/features/checkout/pages/CheckoutPage'));
const BranchCreatePage = lazy(() => import('@/features/signUp/pages/BranchCreate.page'));

// Transform routes to use relative paths under /:locale
const localeChildren = [
    { index: true, element: <Home /> },
    ...ServicesRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...ContactRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...PricingRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...UsRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...ProductsRoutes.map((r) => ({
        ...r,
        path: r.path?.replace(/^\//, '') || r.path,
        children: r.children?.map((c) => ({ ...c, path: c.path?.replace(/^\//, '') || c.path })),
    })),
    ...ComplaintsRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...TermsAndConditionsRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...PrivacyPolicyRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
    ...ClientsRoutes.map((r) => ({ ...r, path: r.path?.replace(/^\//, '') || r.path })),
];
const signUpLocaleChildren = SignUpRoutes.map((r) => ({
    ...r,
    path: r.path?.replace(/^\//, '') || r.path,
}));

const routes = [
    { path: '/', element: <LocaleRedirect /> },
    {
        path: '/:locale',
        element: <LocaleLayout />,
        children: [...localeChildren],
    },
    {
        path: '/:locale/login',
        element: <LoginPage />,
    },
    {
        path: '/:locale/sign-up',
        element: <SignUp />,
        layout: 'default',
        isAuthReq: true,
        children: [...signUpLocaleChildren],
    },
    {
        path: '/:locale/clinico/sign-up',
        element: <ClinicoSignUp />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/:locale/checkout',
        element: <CheckoutPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/:locale/branch-create',
        element: <BranchCreatePage />,
        layout: 'default',
        isAuthReq: true,
    },
];
export { routes };
